export const richTextHelper = {
  currentRange: null,
  _parentElem: null,
  supportRange: typeof document.createRange === 'function',
  saveSelection: function() {
    // console.log(666, 'saveSelection')
    this.currentRange = this.getCurrentRange()
  },
  getCurrentRange() {
    // console.log('getCurrentRange')
    var selection
    var range
    if (this.supportRange) {
      selection = document.getSelection()
      if (selection.getRangeAt && selection.rangeCount) {
        range = document.getSelection().getRangeAt(0)
        this._parentElem = range.commonAncestorContainer
      }
    } else {
      range = document.selection.createRange()
      this._parentElem = range.parentElement()
    }
    return range
  },
  restoreSelection() {
    if (!this.currentRange) {
      return
    }
    var selection
    var range
    if (this.supportRange) {
      selection = document.getSelection()
      selection.removeAllRanges()
      selection.addRange(this.currentRange)
    } else {
      range = document.selection.createRange()
      range.setEndPoint('EndToEnd', this.currentRange)
      if (this.currentRange.text.length === 0) {
        range.collapse(false)
      } else {
        range.setEndPoint('StartToStart', this.currentRange)
      }
      range.select()
    }
  },
  unselect_text_widget(tid) {
    var node = document.querySelector('#u' + tid + ' .my-contenteditable')
    var range = document.createRange()
    range.selectNodeContents(node)
    var selection = window.getSelection()
    selection.removeAllRanges()
  },
  select_text_widget(tid) {
    var node = document.querySelector('#u' + tid + ' .my-contenteditable')
    var range = document.createRange()
    range.selectNodeContents(node)
    var selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
    this.currentRange = selection
  },
  execCommand(name, showUI, value, cb) {
    // console.log('this.currentRange:', this.currentRange)
    // console.log('document.activeElement:', document.activeElement)
    // console.log('document.getSelection().toString():', document.getSelection().toString())
    if (document.getSelection().toString()) {
      document.execCommand(name, showUI, value)
    } else {
      this.restoreSelection()
      document.execCommand(name, showUI, value)
    }
    // document.execCommand(name, showUI, value)
    cb && cb()
  }
}
